import { useContext, useEffect, useState } from "react";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import LittleNotify from "../../UI/Notification/LittleNotify/LittleNotify";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";

const SettingPage = () => {
  const [testTime, setTestTime] = useState(null);
  const [testCount, setTestCount] = useState(null);
  const [success, setSuccess] = useState(null);

  const { getSettings, settings, loading, saveSettings } =
    useContext(AdminContext);

  useEffect(() => {
    document.title = "Настройки";
    getSettings().then((res) => {
      setTestCount(res.number_test);
      setTestTime(res.test_time);
    });
    // .finally((res) => {
    //   console.log(settings)
    // });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmitHandler = async (e) => {
    e.preventDefault();

    try {
      setSuccess(null);
      if (testCount && testTime) {
        const res = await saveSettings(testTime, testCount);
        setSuccess(res.data);
        setTimeout(() => {
          closeNotify();
        }, 13000);
      }
    } catch (err) {
      if (success) setSuccess(null);
    }
  };

  const testCountHandler = (el) => {
    const value = el.target.value.replace(/\+|-/gi, "");
    setTestCount(value);
  };

  const testTimeHandler = (el) => {
    const value = el.target.value.replace(/\+|-/gi, "");
    setTestTime(value);
  };

  const closeNotify = () => {
    setSuccess(null);
  };
  return (
    <>
      {success && <LittleNotify close={closeNotify} title={success} />}
      <section className="settings">
        <div className="container">
          <ButtonBack shortBtn={true} />

          <h1 className="settings__text">Настройки</h1>

          <div className="settings__wrapper">
            {!settings ? (
              <CoveredBackground>
                <Loader />
              </CoveredBackground>
            ) : (
              <form className="settings__form" onSubmit={onSubmitHandler}>
                <div className="settings__item">
                  <label htmlFor="test_time">
                    Время теста в миллисекундах:
                  </label>
                  <input
                    onInput={testTimeHandler}
                    type="number"
                    id="test_time"
                    name="test_time"
                    className="settings__input settings__input_short"
                    placeholder="Время"
                    autoComplete="off"
                    required
                    defaultValue={settings.test_time}
                  />
                </div>
                <div className="settings__item">
                  <label htmlFor="test_count">Кол-во тестовых вопросов:</label>
                  <input
                    type="number"
                    id="test_count"
                    name="test_count"
                    className="settings__input settings__input_short"
                    placeholder="Кол-во"
                    autoComplete="off"
                    onInput={testCountHandler}
                    defaultValue={settings.number_test}
                    required
                  />
                </div>

                <button
                  className="settings__wrapper__link"
                  disabled={loading ? true : false}
                >
                  Сохранить
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default SettingPage;
